import * as React from 'react'
export function FacebookShared({ title, height = 22, width = 22, ...props }) {
  return (
    <div style={{ width, height }}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="110%" height="110%" {...props}>
        <title>{title}</title>
        <g clipPath="url(#a)">
          <path
            fill="#1D252F"
            d="M22 11.25C22 5.313 17.187.5 11.25.5S.5 5.313.5 11.25c0 5.366 3.931 9.813 9.07 10.62v-7.513H6.84V11.25h2.73V8.882c0-2.695 1.605-4.183 4.06-4.183 1.176 0 2.407.21 2.407.21v2.646h-1.355c-1.336 0-1.752.828-1.752 1.68v2.015h2.981l-.476 3.107H12.93v7.512C18.069 21.063 22 16.616 22 11.25Z"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M.5.5H22V22H.5z" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
export default FacebookShared
